import React from 'react'

import { RHFInput } from 'react-hook-form-input'
import useForm from 'react-hook-form'

import {
  Box,
  CircularProgress,
  TextField,
  Typography,
  makeStyles,
} from '@material-ui/core'

import { KeyboardDatePicker } from '@material-ui/pickers'

import { InputDebounce } from 'components/Form'
import * as service from 'service'
import useFetch from 'hooks/useFetch'
import LogAudited from './../../../LogAudited'
import styles from './styles'

const useStyles = makeStyles(styles)

const TabLogAudited = ({ entity, entityId }) => {
  const classes = useStyles()

  const { setValue, register, watch } = useForm({
    defaultValues: {
      field: '',
      actionType: '',
      createdAtGt: '',
      createdAtLt: '',
    },
  })

  const values = watch()

  const { response: responseAudited, isLoading: isLoadingAudited } = useFetch(
    service.recurrence.auditeds.get,
    {
      entity,
      entityId,
      field: values.field,
      actionType: values.actionType,
      createdAtGt: values.createdAtGt,
      createdAtLt: values.createdAtLt,
    },
    [values.field, values.actionType, values.createdAtGt, values.createdAtLt],
  )

  React.useEffect(() => {
    register({ name: 'createdAtGt' })
    register({ name: 'createdAtLt' })
  }, [register])

  const handleChangeDatePicker = (name, value) => {
    setValue(name, value)
  }

  return (
    <>
      <form className={classes.form}>
        <RHFInput
          as={<InputDebounce margin="dense" label="Palavra-chave" />}
          name="field"
          register={register}
          setValue={setValue}
        />

        <KeyboardDatePicker
          margin="dense"
          label="Data inicial"
          name="createdAtGt"
          format="dd/MM/yyyy"
          value={values.createdAtGt || null}
          onChange={event => handleChangeDatePicker('createdAtGt', event)}
          clearable
          clearLabel="Limpar"
          cancelLabel="Cancelar"
        />

        <KeyboardDatePicker
          margin="dense"
          label="Data final"
          name="createdAtLt"
          format="dd/MM/yyyy"
          value={values.createdAtLt || null}
          onChange={event => handleChangeDatePicker('createdAtLt', event)}
          clearable
          clearLabel="Limpar"
          cancelLabel="Cancelar"
        />

        <RHFInput
          as={
            <TextField
              margin="dense"
              label="Ação"
              SelectProps={{ native: true }}
              select
            >
              <option value=""></option>
              <option value="create">Criação</option>
              <option value="update">Atualização</option>
              <option value="destroy">Inativação/Remoção</option>
            </TextField>
          }
          name="actionType"
          register={register}
          setValue={setValue}
        />
      </form>

      {isLoadingAudited && (
        <Box p={2} display="flex" alignItems="center" justifyContent="center">
          <CircularProgress />
        </Box>
      )}

      {!isLoadingAudited &&
        responseAudited &&
        !responseAudited.data['core/auditeds'].length && (
          <Box p={2} display="flex" alignItems="center" justifyContent="center">
            <Typography>Nenhum log encontrado</Typography>
          </Box>
        )}

      {!isLoadingAudited &&
        responseAudited &&
        responseAudited.data['core/auditeds'].map(log => (
          <LogAudited log={log} key={log.id} field={values.field} />
        ))}
    </>
  )
}

export default TabLogAudited
